export const taaStatus = [
  {
    value: 'compliant',
    label: 'Compliant',
  },
  {
    value: 'unknown',
    label: 'Unknown',
  },
  {
    value: 'not_compliant',
    label: 'Not Compliant',
  },
];

export const partStatus = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'obsolete',
    label: 'Obsolete',
  },
  {
    value: 'use_up',
    label: 'Use Up',
  },
];
